import React from 'react';
import { ImageBackground } from 'react-native';
import Images from '../../Images';
import { useIsMobileLayout } from '../../hooks/useIsMobileLayout';

export type SplashScreenBackgroundOwnProps = {
    children?: React.ReactNode;
};

export type SplashScreenBackgroundProps = SplashScreenBackgroundOwnProps;

const SplashScreenBackground: React.FC<SplashScreenBackgroundProps> = (props) => {
    const isMobile = useIsMobileLayout();
    const source = isMobile ? Images.MobileSplash : Images.DesktopSplash;
    return (
        <ImageBackground
            style={{
                width: '100%',
                height: '100%',
            }}
            resizeMode="cover"
            source={source}
            defaultSource={source}
            testID="splash-screen-background"
        >
            {props.children}
        </ImageBackground>
    );
};

export default React.memo(SplashScreenBackground);
